<nb-layout>
  <nb-layout-column>
    <router-outlet *ngIf="!(userGuard.loader$ | async)"></router-outlet>
    <app-full-page-loading *ngIf="(userGuard.loader$ | async)"></app-full-page-loading>
  </nb-layout-column>
</nb-layout>
